import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import UserHomeView from '../views/UserHomeView.vue'
import Course from '../views/course/CourseView.vue'
import Courses from '../views/CoursesView.vue'
import CreateOrganisation from '../views/organisation/Create.vue'
import OrganisationSelect from '../views/organisation/SelectView.vue'
import Settings from '../views/SettingsView.vue'
import Company from '../views/Company.vue'
import Onboarding from '../views/Onboarding.vue'
import LmsCatalogView from '../views/lms/LmsCatalogView.vue'
import LmsModuleView from '../views/lms/LmsModuleView.vue'
import LmsLessonView from '../views/lms/LmsLessonView.vue'
import InstructionView from '../views/lms/InstructionView.vue'
import JoinView from '../views/JoinView.vue'
import SuperAdminCourseList from '../views/superAdmin/CourseListView.vue'
import SuperAdminCourseForm from '../views/superAdmin/CourseFormView.vue'
import SuperAdminOrgList from '../views/superAdmin/OrgListView.vue'
import SuperAdminInstructionLibrary from '../views/superAdmin/InstructionLibraryView.vue'
import { Auth, Hub } from "aws-amplify";
import { store } from '@/store'

let timeout: ReturnType<typeof setTimeout>
function getUserSesion() {
  return Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      store.commit('setUserSession', data);
      store.dispatch("getUserDate");
      return data;
    }
  }).catch(() => {
    store.commit('setUserSession', null);
    return null;
  });
}

function refresToken() {
  timeout = setTimeout(() => {
    Auth.currentSession()
      .then((session) => {
        store.commit('setUserSignInToken', session);
      })
      .catch(() => {
        store.commit('setUserSession', null);
        clearTimeout(timeout);
        router.push({ path: '/login' });
      })
  }, 15 * 60 * 1000)
}

Hub.listen("auth", async (data) => {
  if (data.payload.event === "signIn") {
    localStorage.setItem('organisationId', null);
    localStorage.removeItem('organisationId');
    store.commit('setUserSession', data.payload.data);
    const res = await store.dispatch("getUserDate");
    if (res && res.first_name && res.last_name) {
      return router.push({ name: 'home' });
    }
    await refresToken();
    return router.push({ name: 'login' });
  }

  if (data.payload.event === "signOut") {
    localStorage.removeItem('organisationId');
    store.commit('setUserSession', null);
    store.commit('setUser', null);
    store.commit('organisation/SET_ORGANISATION', {});
    localStorage.setItem('organisationId', 'undefined');
    clearTimeout(timeout);
    router.push({ path: '/login' });
  }
}
);

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    redirect: '/user',
    meta: { requiresAuth: true }
  }, {
    path: '/user',
    name: 'userHome',
    redirect: '/lms',
    //component: UserHomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/company',
    name: 'company',
    component: Company,
    meta: { requiresAuth: true }
  }, {
    path: '/company/create',
    name: 'company/create',
    component: CreateOrganisation,
    meta: { requiresAuth: true }
  },
  {
    path: '/organisationen',
    name: 'organisationSelect',
    component: OrganisationSelect,
    meta: { requiresAuth: true }
  },
  {
    path: '/einstellungen',
    name: 'settings',
    component: Settings,
    meta: { requiresAuth: true }
  },
  {
    path: '/course',
    name: 'courses',
    component: Courses,
    meta: { requiresAuth: true }
  },
  {
    path: '/course/:courseId',
    name: 'course',
    component: Course,
    meta: { requiresAuth: true }
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    //component: Onboarding,
    redirect: '/company/create',
    meta: { requiresAuth: true }
  },
  {
    path: '/lms',
    name: 'lmsCatalog',
    component: LmsCatalogView,
    meta: { requiresAuth: true }
  },
  {
    path: '/lms/instruction/:instructionId',
    name: 'lmsInstruction',
    component: InstructionView,
    meta: { requiresAuth: true }
  },
  {
    path: '/lms/:moduleId',
    name: 'lmsModule',
    component: LmsModuleView,
    meta: { requiresAuth: true }
  },
  {
    path: '/lms/:moduleId/lesson/:lessonId',
    name: 'lmsLesson',
    component: LmsLessonView,
    meta: { requiresAuth: true }
  },
  {
    path: '/j/:token',
    name: 'join',
    component: JoinView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/superadmin',
    name: 'superAdmin',
    redirect: '/superadmin/organisations',
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  },
  {
    path: '/superadmin/organisations',
    name: 'superAdminOrganisations',
    component: SuperAdminOrgList,
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  },
  {
    path: '/superadmin/courses',
    name: 'superAdminCourses',
    component: SuperAdminCourseList,
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  },
  {
    path: '/superadmin/courses/new',
    name: 'superAdminCourseNew',
    component: SuperAdminCourseForm,
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  },
  {
    path: '/superadmin/courses/:courseId',
    name: 'superAdminCourseEdit',
    component: SuperAdminCourseForm,
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  },
  {
    path: '/superadmin/instruction-library',
    name: 'superAdminInstructionLibrary',
    component: SuperAdminInstructionLibrary,
    meta: { requiresAuth: true, requiresSuperAdmin: true }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeResolve(async (to, from, next) => {
  const user = await getUserSesion();
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user || !store.state.user) {
      const res = await getUserSesion();
      if (!res) {
        return next({ path: '/login' });
      }
    }
    // Super-Admin-Status zentral laden (gecacht) – für Guard und Nav-Sichtbarkeit
    await store.dispatch('superAdmin/LOAD_SUPER_ADMIN_STATUS')
    // Super-admin guard
    if (to.matched.some(record => record.meta.requiresSuperAdmin)) {
      if (!store.getters['superAdmin/isSuperAdmin']) {
        return next({ path: '/' });
      }
    }
    return next()
  }
  if (to.name === 'login' && store.state.user && user) {
    return next({ path: '/' });
  }
  return next()
});

export default router
